import React, { useCallback, useState } from 'react';
import { PresentationBar } from './components/PresentationBar';
import { TeaserSnak } from './components/teaser/TeaserSnak';
import { ConceptModal } from './components/concept/ConceptModal';
type AppProps = {
  /** Open the concept window on load. */
  conceptOpenOnLoad?: boolean;
};
export function App({
  conceptOpenOnLoad = false
}: AppProps) {
  const [conceptOpen, setConceptOpen] = useState(conceptOpenOnLoad);
  const closeConcept = useCallback(() => setConceptOpen(false), []);
  return <div className="flex min-h-screen w-full flex-col bg-paper" data-id="element-0" data-mp="2mn5fgugf19n1">
      <PresentationBar onOpenConcept={() => setConceptOpen(true)} data-id="element-1" data-mp="31b8ko1mmwhas" />
      <main className="flex flex-1 flex-col items-center md:justify-center md:py-8" data-id="element-2" data-mp="31cjog1g2xp1w">
        <div className="flex w-full flex-1 flex-col md:block md:w-[390px] md:flex-none" data-id="element-3" data-mp="2whx9xpepbgdl">
          <div className="flex min-h-[640px] flex-1 flex-col overflow-hidden bg-white md:h-[800px] md:max-h-[calc(100vh-130px)] md:min-h-[700px] md:rounded-[44px] md:border-[10px] md:border-ink md:shadow-[0_40px_80px_-30px_rgba(14,27,51,0.45)]" data-id="element-4" data-mp="28sl3uyeo7ofi">
            <TeaserSnak data-id="element-5" data-mp="3ml14tc2x3ukl" />
          </div>
        </div>
        <p className="mt-4 hidden font-mono text-[10px] tracking-[0.2em] text-graphite/70 md:block" data-id="element-6" data-mp="3mjq3diwy2ywn">
          REKOVELLE TEASER SNAK · ~40 SECONDS
        </p>
      </main>
      <ConceptModal open={conceptOpen} onClose={closeConcept} data-id="element-7" data-mp="4ww9qvjiygs" />
    </div>;
}